export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "VehicleMasterImportWorker.480f9dd4810e80be7254.worker.js");
}
